import React from 'react';
import DemoBanner from '@/components/DemoBanner';
import './NewApplication.css';

const NewApplication: React.FC = () => {
  return (
    <div className="new-application-page">
      <div className="new-application-container">
        <DemoBanner />
        {/* Page content will be added here in the future */}
      </div>
    </div>
  );
};

export default NewApplication;

